/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Addsvc API
 * Addsvc 서비스용 API 문서
 * OpenAPI spec version: 1.0
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type {
  AddsvcControllerInsuranceHistoryParams,
  AuthResDto,
  DeviceinfoResDto,
  GetInsuranceResDto,
  InsuranceAddReqDto,
  InsuranceAddResDto,
  InsuranceCancelReqDto,
  InsuranceCancelResDto,
  InsuranceHistoryResDto,
  InsuranceModifyReqDto,
  InsuranceModifyResDto,
  ModifyReqDto,
  ModifyResDto,
  OrderCancelReqDto,
  OrderUpdateReqDto,
  OrderUpdateResDto,
  S1AccountReqDto,
  S1AccountResDto,
  SubscribeResDto,
} from './model';

import { mutator } from '../lib/axios';
import type { ErrorType } from '../lib/axios';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * @summary 인증토큰 요청
 */
export const addsvcControllerAuth = (
  urlToken: string,
  options?: SecondParameter<typeof mutator>,
  signal?: AbortSignal,
) => {
  return mutator<AuthResDto>({ url: `/v1/addsvc/auth/${urlToken}`, method: 'GET', signal }, options);
};

export const getAddsvcControllerAuthQueryKey = (urlToken?: string) => {
  return [`/v1/addsvc/auth/${urlToken}`] as const;
};

export const getAddsvcControllerAuthQueryOptions = <
  TData = Awaited<ReturnType<typeof addsvcControllerAuth>>,
  TError = ErrorType<unknown>,
>(
  urlToken: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof addsvcControllerAuth>>, TError, TData>>;
    request?: SecondParameter<typeof mutator>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getAddsvcControllerAuthQueryKey(urlToken);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof addsvcControllerAuth>>> = ({ signal }) =>
    addsvcControllerAuth(urlToken, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!urlToken, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof addsvcControllerAuth>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type AddsvcControllerAuthQueryResult = NonNullable<Awaited<ReturnType<typeof addsvcControllerAuth>>>;
export type AddsvcControllerAuthQueryError = ErrorType<unknown>;

export function useAddsvcControllerAuth<
  TData = Awaited<ReturnType<typeof addsvcControllerAuth>>,
  TError = ErrorType<unknown>,
>(
  urlToken: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof addsvcControllerAuth>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof addsvcControllerAuth>>,
          TError,
          Awaited<ReturnType<typeof addsvcControllerAuth>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof mutator>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAddsvcControllerAuth<
  TData = Awaited<ReturnType<typeof addsvcControllerAuth>>,
  TError = ErrorType<unknown>,
>(
  urlToken: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof addsvcControllerAuth>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof addsvcControllerAuth>>,
          TError,
          Awaited<ReturnType<typeof addsvcControllerAuth>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof mutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAddsvcControllerAuth<
  TData = Awaited<ReturnType<typeof addsvcControllerAuth>>,
  TError = ErrorType<unknown>,
>(
  urlToken: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof addsvcControllerAuth>>, TError, TData>>;
    request?: SecondParameter<typeof mutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary 인증토큰 요청
 */

export function useAddsvcControllerAuth<
  TData = Awaited<ReturnType<typeof addsvcControllerAuth>>,
  TError = ErrorType<unknown>,
>(
  urlToken: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof addsvcControllerAuth>>, TError, TData>>;
    request?: SecondParameter<typeof mutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getAddsvcControllerAuthQueryOptions(urlToken, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary 서비스 대상 정보 수정
 */
export const addsvcControllerModify = (
  modifyReqDto: ModifyReqDto,
  options?: SecondParameter<typeof mutator>,
  signal?: AbortSignal,
) => {
  return mutator<ModifyResDto>(
    {
      url: `/v1/addsvc/modify`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: modifyReqDto,
      signal,
    },
    options,
  );
};

export const getAddsvcControllerModifyMutationOptions = <TError = ErrorType<unknown>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof addsvcControllerModify>>,
    TError,
    { data: ModifyReqDto },
    TContext
  >;
  request?: SecondParameter<typeof mutator>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof addsvcControllerModify>>,
  TError,
  { data: ModifyReqDto },
  TContext
> => {
  const mutationKey = ['addsvcControllerModify'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof addsvcControllerModify>>, { data: ModifyReqDto }> = (
    props,
  ) => {
    const { data } = props ?? {};

    return addsvcControllerModify(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AddsvcControllerModifyMutationResult = NonNullable<Awaited<ReturnType<typeof addsvcControllerModify>>>;
export type AddsvcControllerModifyMutationBody = ModifyReqDto;
export type AddsvcControllerModifyMutationError = ErrorType<unknown>;

/**
 * @summary 서비스 대상 정보 수정
 */
export const useAddsvcControllerModify = <TError = ErrorType<unknown>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof addsvcControllerModify>>,
      TError,
      { data: ModifyReqDto },
      TContext
    >;
    request?: SecondParameter<typeof mutator>;
  },
  queryClient?: QueryClient,
): UseMutationResult<Awaited<ReturnType<typeof addsvcControllerModify>>, TError, { data: ModifyReqDto }, TContext> => {
  const mutationOptions = getAddsvcControllerModifyMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary 부가서비스 정보 확인
 */
export const addsvcControllerSubscribe = (options?: SecondParameter<typeof mutator>, signal?: AbortSignal) => {
  return mutator<SubscribeResDto>({ url: `/v1/addsvc/subscribe`, method: 'GET', signal }, options);
};

export const getAddsvcControllerSubscribeQueryKey = () => {
  return [`/v1/addsvc/subscribe`] as const;
};

export const getAddsvcControllerSubscribeQueryOptions = <
  TData = Awaited<ReturnType<typeof addsvcControllerSubscribe>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof addsvcControllerSubscribe>>, TError, TData>>;
  request?: SecondParameter<typeof mutator>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getAddsvcControllerSubscribeQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof addsvcControllerSubscribe>>> = ({ signal }) =>
    addsvcControllerSubscribe(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof addsvcControllerSubscribe>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type AddsvcControllerSubscribeQueryResult = NonNullable<Awaited<ReturnType<typeof addsvcControllerSubscribe>>>;
export type AddsvcControllerSubscribeQueryError = ErrorType<unknown>;

export function useAddsvcControllerSubscribe<
  TData = Awaited<ReturnType<typeof addsvcControllerSubscribe>>,
  TError = ErrorType<unknown>,
>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof addsvcControllerSubscribe>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof addsvcControllerSubscribe>>,
          TError,
          Awaited<ReturnType<typeof addsvcControllerSubscribe>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof mutator>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAddsvcControllerSubscribe<
  TData = Awaited<ReturnType<typeof addsvcControllerSubscribe>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof addsvcControllerSubscribe>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof addsvcControllerSubscribe>>,
          TError,
          Awaited<ReturnType<typeof addsvcControllerSubscribe>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof mutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAddsvcControllerSubscribe<
  TData = Awaited<ReturnType<typeof addsvcControllerSubscribe>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof addsvcControllerSubscribe>>, TError, TData>>;
    request?: SecondParameter<typeof mutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary 부가서비스 정보 확인
 */

export function useAddsvcControllerSubscribe<
  TData = Awaited<ReturnType<typeof addsvcControllerSubscribe>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof addsvcControllerSubscribe>>, TError, TData>>;
    request?: SecondParameter<typeof mutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getAddsvcControllerSubscribeQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary 부가서비스 가입정보 등록
 */
export const addsvcControllerOrder = (
  orderUpdateReqDto: OrderUpdateReqDto,
  options?: SecondParameter<typeof mutator>,
  signal?: AbortSignal,
) => {
  return mutator<OrderUpdateResDto>(
    {
      url: `/v1/addsvc/order`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: orderUpdateReqDto,
      signal,
    },
    options,
  );
};

export const getAddsvcControllerOrderMutationOptions = <TError = ErrorType<unknown>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof addsvcControllerOrder>>,
    TError,
    { data: OrderUpdateReqDto },
    TContext
  >;
  request?: SecondParameter<typeof mutator>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof addsvcControllerOrder>>,
  TError,
  { data: OrderUpdateReqDto },
  TContext
> => {
  const mutationKey = ['addsvcControllerOrder'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof addsvcControllerOrder>>, { data: OrderUpdateReqDto }> = (
    props,
  ) => {
    const { data } = props ?? {};

    return addsvcControllerOrder(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AddsvcControllerOrderMutationResult = NonNullable<Awaited<ReturnType<typeof addsvcControllerOrder>>>;
export type AddsvcControllerOrderMutationBody = OrderUpdateReqDto;
export type AddsvcControllerOrderMutationError = ErrorType<unknown>;

/**
 * @summary 부가서비스 가입정보 등록
 */
export const useAddsvcControllerOrder = <TError = ErrorType<unknown>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof addsvcControllerOrder>>,
      TError,
      { data: OrderUpdateReqDto },
      TContext
    >;
    request?: SecondParameter<typeof mutator>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof addsvcControllerOrder>>,
  TError,
  { data: OrderUpdateReqDto },
  TContext
> => {
  const mutationOptions = getAddsvcControllerOrderMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary 부가서비스 취소
 */
export const addsvcControllerOrderCancel = (
  orderCancelReqDto: OrderCancelReqDto,
  options?: SecondParameter<typeof mutator>,
  signal?: AbortSignal,
) => {
  return mutator<ModifyResDto>(
    {
      url: `/v1/addsvc/cancel`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: orderCancelReqDto,
      signal,
    },
    options,
  );
};

export const getAddsvcControllerOrderCancelMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof addsvcControllerOrderCancel>>,
    TError,
    { data: OrderCancelReqDto },
    TContext
  >;
  request?: SecondParameter<typeof mutator>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof addsvcControllerOrderCancel>>,
  TError,
  { data: OrderCancelReqDto },
  TContext
> => {
  const mutationKey = ['addsvcControllerOrderCancel'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof addsvcControllerOrderCancel>>,
    { data: OrderCancelReqDto }
  > = (props) => {
    const { data } = props ?? {};

    return addsvcControllerOrderCancel(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AddsvcControllerOrderCancelMutationResult = NonNullable<
  Awaited<ReturnType<typeof addsvcControllerOrderCancel>>
>;
export type AddsvcControllerOrderCancelMutationBody = OrderCancelReqDto;
export type AddsvcControllerOrderCancelMutationError = ErrorType<unknown>;

/**
 * @summary 부가서비스 취소
 */
export const useAddsvcControllerOrderCancel = <TError = ErrorType<unknown>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof addsvcControllerOrderCancel>>,
      TError,
      { data: OrderCancelReqDto },
      TContext
    >;
    request?: SecondParameter<typeof mutator>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof addsvcControllerOrderCancel>>,
  TError,
  { data: OrderCancelReqDto },
  TContext
> => {
  const mutationOptions = getAddsvcControllerOrderCancelMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary 보상청구 History 요청
 */
export const addsvcControllerInsuranceHistory = (
  params: AddsvcControllerInsuranceHistoryParams,
  options?: SecondParameter<typeof mutator>,
  signal?: AbortSignal,
) => {
  return mutator<InsuranceHistoryResDto>(
    { url: `/v1/addsvc/insurance/history`, method: 'GET', params, signal },
    options,
  );
};

export const getAddsvcControllerInsuranceHistoryQueryKey = (params?: AddsvcControllerInsuranceHistoryParams) => {
  return [`/v1/addsvc/insurance/history`, ...(params ? [params] : [])] as const;
};

export const getAddsvcControllerInsuranceHistoryQueryOptions = <
  TData = Awaited<ReturnType<typeof addsvcControllerInsuranceHistory>>,
  TError = ErrorType<unknown>,
>(
  params: AddsvcControllerInsuranceHistoryParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof addsvcControllerInsuranceHistory>>, TError, TData>>;
    request?: SecondParameter<typeof mutator>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getAddsvcControllerInsuranceHistoryQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof addsvcControllerInsuranceHistory>>> = ({ signal }) =>
    addsvcControllerInsuranceHistory(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof addsvcControllerInsuranceHistory>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type AddsvcControllerInsuranceHistoryQueryResult = NonNullable<
  Awaited<ReturnType<typeof addsvcControllerInsuranceHistory>>
>;
export type AddsvcControllerInsuranceHistoryQueryError = ErrorType<unknown>;

export function useAddsvcControllerInsuranceHistory<
  TData = Awaited<ReturnType<typeof addsvcControllerInsuranceHistory>>,
  TError = ErrorType<unknown>,
>(
  params: AddsvcControllerInsuranceHistoryParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof addsvcControllerInsuranceHistory>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof addsvcControllerInsuranceHistory>>,
          TError,
          Awaited<ReturnType<typeof addsvcControllerInsuranceHistory>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof mutator>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAddsvcControllerInsuranceHistory<
  TData = Awaited<ReturnType<typeof addsvcControllerInsuranceHistory>>,
  TError = ErrorType<unknown>,
>(
  params: AddsvcControllerInsuranceHistoryParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof addsvcControllerInsuranceHistory>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof addsvcControllerInsuranceHistory>>,
          TError,
          Awaited<ReturnType<typeof addsvcControllerInsuranceHistory>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof mutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAddsvcControllerInsuranceHistory<
  TData = Awaited<ReturnType<typeof addsvcControllerInsuranceHistory>>,
  TError = ErrorType<unknown>,
>(
  params: AddsvcControllerInsuranceHistoryParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof addsvcControllerInsuranceHistory>>, TError, TData>>;
    request?: SecondParameter<typeof mutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary 보상청구 History 요청
 */

export function useAddsvcControllerInsuranceHistory<
  TData = Awaited<ReturnType<typeof addsvcControllerInsuranceHistory>>,
  TError = ErrorType<unknown>,
>(
  params: AddsvcControllerInsuranceHistoryParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof addsvcControllerInsuranceHistory>>, TError, TData>>;
    request?: SecondParameter<typeof mutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getAddsvcControllerInsuranceHistoryQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary 보상청구 신청
 */
export const addsvcControllerInsuranceAdd = (
  insuranceAddReqDto: InsuranceAddReqDto,
  options?: SecondParameter<typeof mutator>,
  signal?: AbortSignal,
) => {
  return mutator<InsuranceAddResDto>(
    {
      url: `/v1/addsvc/insurance/add`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: insuranceAddReqDto,
      signal,
    },
    options,
  );
};

export const getAddsvcControllerInsuranceAddMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof addsvcControllerInsuranceAdd>>,
    TError,
    { data: InsuranceAddReqDto },
    TContext
  >;
  request?: SecondParameter<typeof mutator>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof addsvcControllerInsuranceAdd>>,
  TError,
  { data: InsuranceAddReqDto },
  TContext
> => {
  const mutationKey = ['addsvcControllerInsuranceAdd'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof addsvcControllerInsuranceAdd>>,
    { data: InsuranceAddReqDto }
  > = (props) => {
    const { data } = props ?? {};

    return addsvcControllerInsuranceAdd(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AddsvcControllerInsuranceAddMutationResult = NonNullable<
  Awaited<ReturnType<typeof addsvcControllerInsuranceAdd>>
>;
export type AddsvcControllerInsuranceAddMutationBody = InsuranceAddReqDto;
export type AddsvcControllerInsuranceAddMutationError = ErrorType<unknown>;

/**
 * @summary 보상청구 신청
 */
export const useAddsvcControllerInsuranceAdd = <TError = ErrorType<unknown>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof addsvcControllerInsuranceAdd>>,
      TError,
      { data: InsuranceAddReqDto },
      TContext
    >;
    request?: SecondParameter<typeof mutator>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof addsvcControllerInsuranceAdd>>,
  TError,
  { data: InsuranceAddReqDto },
  TContext
> => {
  const mutationOptions = getAddsvcControllerInsuranceAddMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary 보상청구 수정
 */
export const addsvcControllerInsuranceModify = (
  insuranceModifyReqDto: InsuranceModifyReqDto,
  options?: SecondParameter<typeof mutator>,
  signal?: AbortSignal,
) => {
  return mutator<InsuranceModifyResDto>(
    {
      url: `/v1/addsvc/insurance/modify`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: insuranceModifyReqDto,
      signal,
    },
    options,
  );
};

export const getAddsvcControllerInsuranceModifyMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof addsvcControllerInsuranceModify>>,
    TError,
    { data: InsuranceModifyReqDto },
    TContext
  >;
  request?: SecondParameter<typeof mutator>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof addsvcControllerInsuranceModify>>,
  TError,
  { data: InsuranceModifyReqDto },
  TContext
> => {
  const mutationKey = ['addsvcControllerInsuranceModify'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof addsvcControllerInsuranceModify>>,
    { data: InsuranceModifyReqDto }
  > = (props) => {
    const { data } = props ?? {};

    return addsvcControllerInsuranceModify(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AddsvcControllerInsuranceModifyMutationResult = NonNullable<
  Awaited<ReturnType<typeof addsvcControllerInsuranceModify>>
>;
export type AddsvcControllerInsuranceModifyMutationBody = InsuranceModifyReqDto;
export type AddsvcControllerInsuranceModifyMutationError = ErrorType<unknown>;

/**
 * @summary 보상청구 수정
 */
export const useAddsvcControllerInsuranceModify = <TError = ErrorType<unknown>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof addsvcControllerInsuranceModify>>,
      TError,
      { data: InsuranceModifyReqDto },
      TContext
    >;
    request?: SecondParameter<typeof mutator>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof addsvcControllerInsuranceModify>>,
  TError,
  { data: InsuranceModifyReqDto },
  TContext
> => {
  const mutationOptions = getAddsvcControllerInsuranceModifyMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary 보상청구 조회
 */
export const addsvcControllerGetInsurance = (
  id: string,
  options?: SecondParameter<typeof mutator>,
  signal?: AbortSignal,
) => {
  return mutator<GetInsuranceResDto>({ url: `/v1/addsvc/insurance/${id}`, method: 'GET', signal }, options);
};

export const getAddsvcControllerGetInsuranceQueryKey = (id?: string) => {
  return [`/v1/addsvc/insurance/${id}`] as const;
};

export const getAddsvcControllerGetInsuranceQueryOptions = <
  TData = Awaited<ReturnType<typeof addsvcControllerGetInsurance>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof addsvcControllerGetInsurance>>, TError, TData>>;
    request?: SecondParameter<typeof mutator>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getAddsvcControllerGetInsuranceQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof addsvcControllerGetInsurance>>> = ({ signal }) =>
    addsvcControllerGetInsurance(id, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof addsvcControllerGetInsurance>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type AddsvcControllerGetInsuranceQueryResult = NonNullable<
  Awaited<ReturnType<typeof addsvcControllerGetInsurance>>
>;
export type AddsvcControllerGetInsuranceQueryError = ErrorType<unknown>;

export function useAddsvcControllerGetInsurance<
  TData = Awaited<ReturnType<typeof addsvcControllerGetInsurance>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof addsvcControllerGetInsurance>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof addsvcControllerGetInsurance>>,
          TError,
          Awaited<ReturnType<typeof addsvcControllerGetInsurance>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof mutator>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAddsvcControllerGetInsurance<
  TData = Awaited<ReturnType<typeof addsvcControllerGetInsurance>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof addsvcControllerGetInsurance>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof addsvcControllerGetInsurance>>,
          TError,
          Awaited<ReturnType<typeof addsvcControllerGetInsurance>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof mutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAddsvcControllerGetInsurance<
  TData = Awaited<ReturnType<typeof addsvcControllerGetInsurance>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof addsvcControllerGetInsurance>>, TError, TData>>;
    request?: SecondParameter<typeof mutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary 보상청구 조회
 */

export function useAddsvcControllerGetInsurance<
  TData = Awaited<ReturnType<typeof addsvcControllerGetInsurance>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof addsvcControllerGetInsurance>>, TError, TData>>;
    request?: SecondParameter<typeof mutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getAddsvcControllerGetInsuranceQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary 보상청구 취소
 */
export const addsvcControllerInsuranceCancel = (
  insuranceCancelReqDto: InsuranceCancelReqDto,
  options?: SecondParameter<typeof mutator>,
  signal?: AbortSignal,
) => {
  return mutator<InsuranceCancelResDto>(
    {
      url: `/v1/addsvc/insurance/cancel`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: insuranceCancelReqDto,
      signal,
    },
    options,
  );
};

export const getAddsvcControllerInsuranceCancelMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof addsvcControllerInsuranceCancel>>,
    TError,
    { data: InsuranceCancelReqDto },
    TContext
  >;
  request?: SecondParameter<typeof mutator>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof addsvcControllerInsuranceCancel>>,
  TError,
  { data: InsuranceCancelReqDto },
  TContext
> => {
  const mutationKey = ['addsvcControllerInsuranceCancel'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof addsvcControllerInsuranceCancel>>,
    { data: InsuranceCancelReqDto }
  > = (props) => {
    const { data } = props ?? {};

    return addsvcControllerInsuranceCancel(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AddsvcControllerInsuranceCancelMutationResult = NonNullable<
  Awaited<ReturnType<typeof addsvcControllerInsuranceCancel>>
>;
export type AddsvcControllerInsuranceCancelMutationBody = InsuranceCancelReqDto;
export type AddsvcControllerInsuranceCancelMutationError = ErrorType<unknown>;

/**
 * @summary 보상청구 취소
 */
export const useAddsvcControllerInsuranceCancel = <TError = ErrorType<unknown>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof addsvcControllerInsuranceCancel>>,
      TError,
      { data: InsuranceCancelReqDto },
      TContext
    >;
    request?: SecondParameter<typeof mutator>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof addsvcControllerInsuranceCancel>>,
  TError,
  { data: InsuranceCancelReqDto },
  TContext
> => {
  const mutationOptions = getAddsvcControllerInsuranceCancelMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary 부가서비스 정보 확인
 */
export const addsvcControllerDeviceinfo = (options?: SecondParameter<typeof mutator>, signal?: AbortSignal) => {
  return mutator<DeviceinfoResDto>({ url: `/v1/addsvc/deviceinfo`, method: 'GET', signal }, options);
};

export const getAddsvcControllerDeviceinfoQueryKey = () => {
  return [`/v1/addsvc/deviceinfo`] as const;
};

export const getAddsvcControllerDeviceinfoQueryOptions = <
  TData = Awaited<ReturnType<typeof addsvcControllerDeviceinfo>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof addsvcControllerDeviceinfo>>, TError, TData>>;
  request?: SecondParameter<typeof mutator>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getAddsvcControllerDeviceinfoQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof addsvcControllerDeviceinfo>>> = ({ signal }) =>
    addsvcControllerDeviceinfo(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof addsvcControllerDeviceinfo>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type AddsvcControllerDeviceinfoQueryResult = NonNullable<Awaited<ReturnType<typeof addsvcControllerDeviceinfo>>>;
export type AddsvcControllerDeviceinfoQueryError = ErrorType<unknown>;

export function useAddsvcControllerDeviceinfo<
  TData = Awaited<ReturnType<typeof addsvcControllerDeviceinfo>>,
  TError = ErrorType<unknown>,
>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof addsvcControllerDeviceinfo>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof addsvcControllerDeviceinfo>>,
          TError,
          Awaited<ReturnType<typeof addsvcControllerDeviceinfo>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof mutator>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAddsvcControllerDeviceinfo<
  TData = Awaited<ReturnType<typeof addsvcControllerDeviceinfo>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof addsvcControllerDeviceinfo>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof addsvcControllerDeviceinfo>>,
          TError,
          Awaited<ReturnType<typeof addsvcControllerDeviceinfo>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof mutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAddsvcControllerDeviceinfo<
  TData = Awaited<ReturnType<typeof addsvcControllerDeviceinfo>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof addsvcControllerDeviceinfo>>, TError, TData>>;
    request?: SecondParameter<typeof mutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary 부가서비스 정보 확인
 */

export function useAddsvcControllerDeviceinfo<
  TData = Awaited<ReturnType<typeof addsvcControllerDeviceinfo>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof addsvcControllerDeviceinfo>>, TError, TData>>;
    request?: SecondParameter<typeof mutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getAddsvcControllerDeviceinfoQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary S1 통합계정 확인 요청
 */
export const addsvcControllerS1Account = (
  s1AccountReqDto: S1AccountReqDto,
  options?: SecondParameter<typeof mutator>,
  signal?: AbortSignal,
) => {
  return mutator<S1AccountResDto>(
    {
      url: `/v1/addsvc/s1Account`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: s1AccountReqDto,
      signal,
    },
    options,
  );
};

export const getAddsvcControllerS1AccountMutationOptions = <TError = ErrorType<unknown>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof addsvcControllerS1Account>>,
    TError,
    { data: S1AccountReqDto },
    TContext
  >;
  request?: SecondParameter<typeof mutator>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof addsvcControllerS1Account>>,
  TError,
  { data: S1AccountReqDto },
  TContext
> => {
  const mutationKey = ['addsvcControllerS1Account'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof addsvcControllerS1Account>>,
    { data: S1AccountReqDto }
  > = (props) => {
    const { data } = props ?? {};

    return addsvcControllerS1Account(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AddsvcControllerS1AccountMutationResult = NonNullable<
  Awaited<ReturnType<typeof addsvcControllerS1Account>>
>;
export type AddsvcControllerS1AccountMutationBody = S1AccountReqDto;
export type AddsvcControllerS1AccountMutationError = ErrorType<unknown>;

/**
 * @summary S1 통합계정 확인 요청
 */
export const useAddsvcControllerS1Account = <TError = ErrorType<unknown>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof addsvcControllerS1Account>>,
      TError,
      { data: S1AccountReqDto },
      TContext
    >;
    request?: SecondParameter<typeof mutator>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof addsvcControllerS1Account>>,
  TError,
  { data: S1AccountReqDto },
  TContext
> => {
  const mutationOptions = getAddsvcControllerS1AccountMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
